import { PresenceSeuil } from '../SANDRE/presence-seuil';
import { PresenceGué } from '../SANDRE/presence-gue';
import { ColmatageLit } from '../SANDRE/colmatage-lit';

export class MorphologieLit {
    id: number;
    interventionId: number;
    
    PresenceSeuil: PresenceSeuil;
    PresenceGue: PresenceGué;
    ColmatageLit: ColmatageLit;
    Canalisation: boolean;
    Navigation: boolean;
    Curage: boolean;
    Recalibrage: boolean;
    Rectification: boolean;

    static mapFromJSON(json: any): MorphologieLit {
        const m = new MorphologieLit();

        m.PresenceGue = json.presenceGue;
        m.PresenceSeuil = json.presenceSeuil;
        m.ColmatageLit = json.colmatageLit;
        m.Canalisation = json.canalisation;
        m.Navigation = json.navigation;
        m.Curage = json.curage;
        m.Recalibrage = json.recalibrage;
        m.Rectification = json.rectification;

        return m;
    }
}
